var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useCallback, useContext } from 'react';
import { ThemeContext } from 'styled-components';
import IconWrapper from '../IconWrapper';
import CheckIcon16 from '@bankiru/icons/react/Check16';
import CheckTinyIcon16 from '@bankiru/icons/react/CheckTiny16';
import { StyledIcon, StyledInput, StyledLabel } from './Checkbox.styled';
import { DATA_ATTRS } from '../../utils/gtm';
import { defaultThemeCheckbox } from './constant';
import { mergeTheme } from '../../utils/mergeTheme';
export const checkboxIconWrapperDataTestId = 'checkbox-icon-wrapper';
const icon = {
  fs16: React.createElement(CheckIcon16, null),
  fs14: React.createElement(CheckTinyIcon16, null),
  fs12: React.createElement(CheckTinyIcon16, null)
};
const defaultProps = {
  size: 'fs16'
};

const Checkbox = _a => {
  var {
    isChecked,
    onChange,
    isDisabled,
    value,
    name,
    title,
    isError,
    isBordered,
    size = defaultProps.size,
    dataTest
  } = _a,
      props = __rest(_a, ["isChecked", "onChange", "isDisabled", "value", "name", "title", "isError", "isBordered", "size", "dataTest"]);

  const context = useContext(ThemeContext);
  const theme = mergeTheme(defaultThemeCheckbox, context);
  const sizeOverride = size === 'large' || size === 'medium' ? 'fs16' : size;
  const changeHandler = useCallback(event => {
    onChange && onChange(event.target.checked, event);
  }, [onChange]);
  return React.createElement(StyledLabel, {
    isDisabled: isDisabled,
    isBordered: isBordered,
    size: sizeOverride,
    theme: theme
  }, React.createElement(StyledInput, Object.assign({
    type: "checkbox",
    onChange: changeHandler,
    name: name,
    value: value,
    checked: isChecked,
    disabled: isDisabled,
    "data-role": "checkbox",
    "data-test": dataTest,
    theme: theme
  }, props[DATA_ATTRS])), React.createElement(StyledIcon, {
    isError: isError,
    isDisabled: isDisabled,
    size: sizeOverride,
    theme: theme,
    "data-testid": checkboxIconWrapperDataTestId
  }, React.createElement(IconWrapper, null, sizeOverride && icon[sizeOverride])), title && React.createElement("span", null, title));
};

export default Checkbox;